import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

/**
 * NotFoundPage Component
 * 
 * 404 error page displayed when a route is not found.
 * 
 * Features:
 * - Friendly error message
 * - Navigation back to home
 * - Playful design matching app aesthetic
 * 
 * @validates Requirements 22.3, 5.11
 */
export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center space-y-6 px-4">
        {/* Playful illustration */}
        <div className="text-8xl animate-bounce">
          🔤
        </div>
        
        {/* Error message */}
        <div className="space-y-2">
          <h1 className="font-display text-6xl font-bold text-slate-900">
            {t('errors.notFound.title')}
          </h1>
          <p className="text-xl text-slate-600">
            {t('errors.notFound.heading')}
          </p>
          <p className="text-slate-500 max-w-md mx-auto">
            {t('errors.notFound.message')}
          </p>
        </div>
        
        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <Link
            to="/"
            className="btn-primary"
          >
            {t('errors.notFound.backHome')}
          </Link>
          <Link
            to="/login"
            className="btn-outline"
          >
            {t('errors.notFound.login')}
          </Link>
        </div>
        
        {/* Fun message */}
        <p className="text-sm text-slate-400 pt-8">
          {t('errors.notFound.hint')}
        </p>
      </div>
    </div>
  );
}
